import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';

export default function OnboardingWelcome() {
  const classes = {
    welcome_circle_1: {
      position: 'absolute',
      width: '1217px',
      height: '1238px',
      left: '732px',
      top: '-442px',
      background: 'var(--kea-color-primary)',
      borderRadius: '50%',
      zIndex: 0,
    },
    welcome_circle_2: {
      boxSizing: 'border-box',
      position: 'absolute',
      width: '1217.39px',
      height: '1215px',
      left: '-9.26px',
      top: '-267px',
      border: '1px solid var(--kea-color-primary-soft)',
      borderRadius: '50%',
      zIndex: '1',
    },
    welcome_circle_3: {
      boxSizing: 'border-box',
      position: 'absolute',
      width: '1217.39px',
      height: '1215px',
      left: '-61px',
      top: '-267px',
      background: '#FFFFFF',
      border: '1px solid var(--kea-color-primary-soft)',
      borderRadius: '50%',
      zIndex: '2',
    },
  };
  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={12} md={6}>
        <Typography variant="h4" gutterBottom>
          <IntlMessages id="ui.setupVisualRecs.onboardingWelcome.welcomeToKeaLabsVisualRecommendations" />
        </Typography>
        <br />
        <br />
        <br />
        <Typography variant="body1" paragraph align="left">
          <IntlMessages id="ui.setupVisualRecs.onboardingWelcome.thankYouForConsideringKeaLabsAsYourSearchSolution" />
          <br />
          <IntlMessages id="ui.setupVisualRecs.onboardingWelcome.ourVisualRecommendationsToolIsDesignedToHelpBusinessesProvide" />
        </Typography>
        <Typography variant="body1" paragraph align="left">
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <IntlMessages id="ui.setupVisualRecs.onboardingWelcome.getStartedByClickingNextToLearnMoreAboutHow" />
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <img src={require('assets/images/onboarding/visual_recs_onboarding_welcome.png')} />
      </Grid>
      <div style={{ position: 'static', zIndex: -1 }}>
        <div style={classes.welcome_circle_1} />
        <div style={classes.welcome_circle_2} />
        <div style={classes.welcome_circle_3} />
      </div>
    </Grid>
  );
}
